import { PartnerDecision, PartnerDecisionCause, PartnerDecisionReason } from "@bbj-types/socialApply/enum";
import { isValidPhoneNumber } from "@root/utils/phoneLib";
import { addressSchema } from "@root/utils/resolvers/address";
import { type InferType, array, boolean, date, object, string } from "yup";

const convocationSchema = object({
  date: date(),
  reason: string().oneOf(Object.values(PartnerDecisionReason)),
});

const decisionSchema = object({
  partnerDecision: string().oneOf(Object.values(PartnerDecision)).required("La décision est obligatoire"),
  cause: string()
    .oneOf(Object.values(PartnerDecisionCause))
    .test((value, context) => {
      if (
        (value && context.parent.partnerDecision === PartnerDecision.NOT_INTEGRATED) ||
        (!value && context.parent.partnerDecision === PartnerDecision.INTEGRATED)
      ) {
        return true;
      }
      throw context.createError({
        path: context.path,
        message: "Le motif est obligatoire",
      });
    })
    .nullable(),
  firstReceptionDate: date(),
  assessmentDate: date(),
  firstConvocation: convocationSchema.default(undefined).optional(),
  secondConvocation: convocationSchema.default(undefined).optional(),
  thirdConvocation: convocationSchema.default(undefined).optional(),
});

export const partnerFeedbackFormSchema = object({
  partnerFeedback: object({
    accompanierName: string().required("Le prénom et le nom de l’accompagnateur sont obligatoires"),
    name: string().required("Le nom du partenaire est obligatoire"),
    email: string().email("L'email n'est pas bien formaté"),
    phone: string().test(
      "valid-phone",
      "Le format du numéro n'est pas valide",
      (val) => !val || isValidPhoneNumber(val)
    ),
    address: addressSchema.default(null).nullable().optional(),
    decision: decisionSchema.required(),
  }),
  sponsorsLogo: array()
    .of(
      object({
        label: string().required(),
        value: string().required(),
        uri: string().required(),
        required: boolean().required(),
      })
    )
    .required(),
});

export type TPartnerFeedbackFormResolver = InferType<typeof partnerFeedbackFormSchema>;
